module.exports = __webpack_public_path__ + "img/Screen Shot 2021-04-18 at 6.55.37 PM.1721bf91.png";